import Swal from 'sweetalert2'

export const toastSuccess = (text) => Swal.fire({
    icon: 'success',
    text,
    toast: true,
    position: 'top-end',
    timer: 2500,
    showConfirmButton: false
})

export const toastError = (text) => Swal.fire({
    icon: 'error',
    text,
    toast: true,
    position: 'top-end',
    timer: 3500,
    showConfirmButton: false
})

export const toastInfo = (text) => Swal.fire({
    icon: 'info',
    text,
    toast: true,
    position: 'top-end',
    timer: 3000,
    showConfirmButton: false
})
